import { setColorAlpha } from "./helpers";
import { tokens } from "./tokens";

type SeverityColors = {
  glow: string;
  icon: string;
  iconBg: string;
  title: string;
  gradientStart: string;
  gradientEnd: string;
  border: string;
};

const { color } = tokens;

const severity = (
  base: string,
  gradientStart: string,
  gradientEnd: string,
): SeverityColors => ({
  glow: base,
  icon: base,
  iconBg: setColorAlpha(base, 0.2),
  title: base,
  gradientStart,
  gradientEnd,
  border: setColorAlpha(base, 0.3),
});

/**
 * Alert-card colour channel, keyed by `AlertCardSeverity` (common). glow /
 * icon / title / iconBg / border derive from the status authority in
 * tokens.ts so an alert card and a status pill cannot disagree; only the
 * two dark card-gradient stops are literals. Moved here from
 * common/src/types/AlertCard.ts (rank-9 step 4) - values unchanged.
 */
export const ALERT_SEVERITY_COLORS = {
  error: severity(color.statusCritical, "#3a1215", "#170505"),
  warning: severity(color.statusWarning, "#3a2a12", "#170d05"),
  // Coverage gap - the same amber as the dashboard coverage badge, so
  // "Sensor Not Reporting" is one colour on every surface.
  coverage: severity(color.statusOffline, "#3a3212", "#171305"),
  // deltaBlue #0072C6 is the original literal - NOT tokens.color.info (#70BBF7).
  info: severity(color.deltaBlue, "#122a3a", "#050d17"),
  success: severity(color.statusGood, "#123a1a", "#05170a"),
};
